import React from "react";
import ProfileImg from "../../assets/images/dummy.png";

const UserProfileBox = (props) => {
  return (
    <div
      className={`nav-link box ${props.activeClass} border-0 mb-3 me-3 rounded-2  bg-white position-relative primary_color`}
      id="v-pills-home-tab"
      data-bs-toggle="pill"
      data-bs-target={`#profile-${props.userId}`}
      role="tab"
      aria-controls="v-pills-home"
      aria-selected="true"
    >

      <div className="d-flex flex-row bd-highlight">
        <div className=" bd-highlight">
          <div className="student-info">
            {props.studentImg !==null && props.studentImg !=='' ? (
           
              <img
                src={`${process.env.REACT_APP_API_URL}/public/uploads/profile_picture/${props.studentImg}`}
                alt="Profile"
                className="profile"
              />
            ) : (
              <img
                src={ProfileImg}
                style={{ width: "inherit" }}
                alt="Profile"
                className="profile"
              />
            )}
          </div>
        </div>
        <div
          className="bd-highlight align-self-center"
          onClick={() => props.onClick(props.userId)}
          style={{ cursor: "pointer" }}
        >
          <div className="student-info">
            <div className="st_name">{props.studentName.length>11?props.studentName.substr(0,11)+'...':props.studentName}</div>
            <span className="form_number">Form No : {props.formNumber}</span>
            <span className="form_number">Class: {props.studentClass}</span>
            <span className="form_number mb-2">
              Course Code: {props.courseCode} {props.courseName}{" "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileBox;
